<template>
  <v-card
    elevation="2"
    class="pa-4"
    :color="showBg ? undefined : 'grey lighten-3'"
    :class="[
      alignCenter ? 'mx-auto' : '',
      showBg ? `credit-card ${card.cardType.toLowerCase()}` : '',
    ]"
    :max-width="$vuetify.breakpoint.lgAndUp ? 360 : 400"
    :dark="showBg"
  >
    <div class="d-flex align-center">
      <div :class="{ 'mr-auto': alignCenter }">
        <v-img
          src="~@/assets/imgs/credit-card.png"
          contain
          :max-width="$vuetify.breakpoint.lgAndUp ? 48 : 36"
        ></v-img>
      </div>
      <div>
        <template v-if="card.cardType == CardType.VISA">
          <v-img
            src="~@/assets/imgs/vbm-wht01.png"
            max-width="100"
            height="72"
            max-height="72"
            contain
          ></v-img>
        </template>
        <template v-else-if="card.cardType == CardType.MASTERCARD">
          <v-img
            src="~@/assets/imgs/mc_symbol.svg"
            aspect-ratio="1"
            max-width="100"
            max-height="72"
          ></v-img>
        </template>
        <template v-else-if="card.cardType == CardType.JCB">
          <v-img
            src="~@/assets/imgs/JCB_logo.svg"
            aspect-ratio="1"
            max-width="100"
            max-height="72"
          ></v-img>
        </template>
        <template v-else>
          <div style="width: 100%; height: 72px"></div>
        </template>
      </div>
    </div>
    <v-card-text
      class="pa-0 mt-2"
      :class="{ 'mb-2': $vuetify.breakpoint.lgAndUp }"
    >
      <template v-if="!showBg">
        <div
          class="text-left text--primary"
          :class="[$vuetify.breakpoint.lgAndUp ? 'display-1' : 'headline']"
        >
          ∗∗∗∗ ∗∗∗∗ ∗∗∗∗ {{ card.cardNo.substr(-4) }}
        </div>
        <div class="d-flex mt-2">
          <div class="flex-grow-1 text-left text-truncate">
            <div class="caption text--secondary">CARD HOLDER</div>
            <span
              class="text-uppercase text-truncate text--primary font-weight-bold"
              :class="[$vuetify.breakpoint.lgAndUp ? 'body-2' : 'body-2']"
              >{{ card.holderName }}</span
            >
          </div>
          <div
            class="text-left"
            :class="[$vuetify.breakpoint.lgAndUp ? 'body-2' : 'body-2']"
          >
            <div class="caption text--secondary">EXPIRES</div>
            <span class="text--primary">
              {{ card.expires }}
            </span>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="text-left white--text"
          :class="[$vuetify.breakpoint.lgAndUp ? 'display-1' : 'headline']"
        >
          ∗∗∗∗ ∗∗∗∗ ∗∗∗∗ {{ card.cardNo.substr(-4) }}
        </div>
        <div class="d-flex mt-2">
          <div class="flex-grow-1 text-left text-truncate">
            <div class="caption white--text">CARD HOLDER</div>
            <span
              class="text-uppercase text-truncate white--text font-weight-bold"
              :class="[$vuetify.breakpoint.lgAndUp ? 'body-2' : 'body-2']"
              >{{ card.holderName }}</span
            >
          </div>
          <div
            class="text-left"
            :class="[$vuetify.breakpoint.lgAndUp ? 'body-2' : 'body-2']"
          >
            <div class="caption white--text">EXPIRES</div>
            <span class="white--text font-weight-bold">
              {{ card.expires }}
            </span>
          </div>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { types as CardType } from "credit-card-type";
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
    alignCenter: {
      type: Boolean,
      default: true,
    },
    showBg: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    CardType: CardType,
  }),
};
</script>

<style lang="scss" scoped>
$linearFrom: rgba(0, 0, 0, 0.2);
$linearEnd: rgba(0, 0, 0, 0.5);

@mixin cardBg($img) {
  background-image: linear-gradient($linearFrom, $linearEnd), url($img) !important;
  background-image: -webkit-linear-gradient($linearFrom, $linearEnd), url($img) !important;
  background-image: -moz-linear-gradient($linearFrom, $linearEnd), url($img) !important;
  background-image: -o-linear-gradient($linearFrom, $linearEnd), url($img) !important;
  background-image: -ms-linear-gradient($linearFrom, $linearEnd), url($img) !important;
}

.credit-card {
  background-size: cover;
  &.visa {
    @include cardBg("~@/assets/imgs/bg-cards/19.jpeg");
  }
  &.mastercard {
    @include cardBg("~@/assets/imgs/bg-cards/10.jpeg");
  }
  &.jcb {
    @include cardBg("~@/assets/imgs/bg-cards/22.jpeg");
  }
}
</style>